<template>
<div class="consulta-empresa">
    <ContainerTitle icon="search" title="Consultar Empresa"/>

    <ConsultarEmpresaFiltro @filter-empresa="filtrar" />
    <ConsultarEmpresaList :rows="rows"/>
    
    <ModalAlert id="empresa-list-vazio">
        <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
        Empresa disponível para prospecção/implantação.
    </ModalAlert>

    <PaginationTable :page="page" :totalPages="result.totalPages" :totalItens="result.totalItens" @changePage="changePage" />
</div>
</template>

<script>
import ConsultarEmpresaFiltro from './components/ConsultarEmpresaFiltro'
import ConsultarEmpresaList   from './components/ConsultarEmpresaList'
import EmpresaResource from "@/resources/EmpresaResource"
import ModalAlert from "../../../../commons/ModalAlert.vue"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import PaginationTable from "@/components/commons/table/components/PaginationTable.vue";

export default {
    name: 'ConsultarEmpresa',
    components: {
        ConsultarEmpresaFiltro,
        ConsultarEmpresaList,
        ModalAlert,
        DynamicIcon,
        ContainerTitle,
        PaginationTable
    },
	data() {
		return {
            rows: [],
            page: 1,
            result: {
				list: [],
				totalPages: 0,
				totalItens: 0
			}
		}
	},
    methods: {
        changePage( page ){
			this.page = page
			this.filtrar(this.actualFilter)
		},
        filtrar(formFilter) {

			this.lastFilter = {...formFilter}
			let filter = {
				page: this.page,
				...formFilter
			}

			EmpresaResource.consultar(filter.cnpj, filter.name, filter.page, filter.size, {showLoader: true})
			.then((result) => {
                if(!Array.isArray(result))
                {
                    this.rows = [];
                }

                if(!result.list.length)
                {
                    this.$bvModal.show("empresa-list-vazio");
                }

                this.result = result

                this.rows = result.list.map( elem =>  { 
                    return {
                    ...elem,
                    status: elem.status == 1 ? "Empresa não disponível para prospecção/implantação" : "Empresa disponível para prospecção/implantação",
                    }
                })
                
			})
            .catch(()=>{
                this.rows = []

            })
		},
        formateDate(value) {
            if(!value)
            {
                return ""
            }
            let date = new Date(value);
            return date.getDate() +'/'+ (date.getMonth()+1) +'/'+ date.getFullYear() 
        }
    },
    created(){
        this.filtrar()
    }
}
</script>

<style scoped>
.consulta-empresa {
	font-size: 18px;
	text-align: left;
    background-color: #fff;
}
</style>